module.exports = __webpack_public_path__ + "img/baa2542.png";